import PolygonBase from './PolygonBase';
import shapeOpenBracket from '../assets/icons/shapeOpenBracket.svg';
import { svgToIcon } from '../utils/svg';
import { roundRectEdgePathString } from './utils';

class ShapeOpenBracket extends PolygonBase {
  // Brackets are stroke only and don't make sense for boolean operations
  booleanOperationCompatible = false;

  static renderIcon() {
    return svgToIcon(shapeOpenBracket);
  }

  static defaultWidth() {
    return 70;
  }

  static pathStrokeOnly = true;

  static pathString() {
    return `
      M -0.25 0.5
      L -0.4 0.5
      R 0.1 2
      L -0.5 -0.4
      R 0.1 3
      L -0.25 -0.5
      `;
  }

  static edgePathString() {
    return roundRectEdgePathString(0.1);
  }
}

export default ShapeOpenBracket;
